import "./TagList.css";
import { sortTags } from "../../util/sortTags";
import TagButton from "../TagButton/TagButton";

export default function TagList({ tags }) {
    return (
        <div className="tagList">
            <p>tags:</p>
            <ul>
                {sortTags(tags).map((tag) => (
                    <li key={tag._id} id={tag._id}>
                        <TagButton tag={tag} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
